import React from "react";
import { useField } from "react-final-form";
import { Grid } from "@material-ui/core";
import SubcontractorInput from "./SubcontractorInput";
import VehicleSizeInput from "./VehicleSizeInput";
import StartDateInput from "./StartDateInput";
import EndDateInput from "./EndDateInput";

const AssignedSubcontractorInput = () => {
  const assignedSubcontractorField = useField("route.assignedSubcontractor");

  return (
    <>
      <Grid item xs={12}>
        <SubcontractorInput record={assignedSubcontractorField.input.value} />
      </Grid>
      <Grid item xs={6}>
        <StartDateInput record={assignedSubcontractorField.input.value} />
      </Grid>
      <Grid item xs={6}>
        <EndDateInput record={assignedSubcontractorField.input.value} />
      </Grid>
      <Grid item xs={6}>
        <VehicleSizeInput record={assignedSubcontractorField.input.value} />
      </Grid>
    </>
  );
};

export default AssignedSubcontractorInput;
